import { render } from "./ConsultaPlanillas.vue?vue&type=template&id=0d27b700&scoped=true"
import script from "./ConsultaPlanillas.vue?vue&type=script&lang=js"
export * from "./ConsultaPlanillas.vue?vue&type=script&lang=js"

import "./ConsultaPlanillas.vue?vue&type=style&index=0&id=0d27b700&scoped=true&lang=css"

import exportComponent from "C:\\Software\\Aplicaciones\\allikamay\\frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0d27b700"]])

export default __exports__